export default {
  en: {
    today: 'Today',
    yesterday: 'Yesterday',
    no_more_messages: 'No more messages',
    new_messages_indicator: 'New messages',
    mark_all_as_read: 'Mark all as read',
    unread_messages_separator_up: {
      one: '1 unread message',
      other: '%{count} unread messages',
    },
    unread_messages_separator: {
      one: '1 new message',
      other: '%{count} new messages',
    },
    system_message: {
      create_chat: {
        message: '%{actor_name} created the chat',
        message_actor: 'You created the chat',
      },
      join_chat: {
        message: '%{actor_name} joined the chat',
        message_actor: 'You joined the chat',
      },
      leave_chat: {
        message: '%{actor_name} left the chat',
        message_actor: 'You left the chat',
      },
      add_user: {
        message: '%{actor_name} added %{subject_name}',
        message_actor: 'You added %{subject_name}',
        message_subject: '%{actor_name} added you',
      },
      remove_user: {
        message: '%{actor_name} removed %{subject_name}',
        message_actor: 'You removed %{subject_name}',
        message_subject: '%{actor_name} removed you',
      },
    },
  },
};
